export const GET_SENIOR_CITIZEN = 'SENIOR/get_senior_citizen'
export const SHOW_SENIOR_CITIZEN = 'SENIOR/show_senior_citizen'
export const APPROVE_TRANSACTION = 'SENIOR/approve_transaction';
export const REJECT_TRANSACTION = 'SENIOR/reject_transaction';

export const GET_INCIDENT = 'EHELP/get_incident';
export const SHOW_INCIDENT = 'EHELP/show_incident';

// not needed yet
export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  occupational_permit_amount: {
    label: 'Occupational Permit',
  },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain_amount: {
    label: 'Gram Stain',
  },
};

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
  last_name: '',
  middle_name: '',
  first_name: '',
  extension_name: '',
  gender: '',
  mobile_number: '',
  telephone_number: '',
  birth_date: '',
  civil_status: '',
  highest_educational_attainment: '',
  institution_code: '',
  work_description_code: '',
  citizenship_code: '',
};

export const BUSINESS_FORM = {
  business_establishment_id: '',
  business_establishments: '',
  business_establishments_address: '',
  number_of_additional_copy: '',
};

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];

export const HIGHEST_EDUCATIONAL_ATTAINMENT = [
  {
    label: 'No Grade Completed',
    value: 'No Grade Completed',
  },
  {
    label: 'Preschool',
    value: 'Preschool',
  },
  {
    label: 'Elementary Undergraduate',
    value: 'Elementary Undergraduate',
  },
  {
    label: 'Elementary Graduate',
    value: 'Elementary Graduate',
  },
  {
    label: 'ALS Elementary',
    value: 'ALS Elementary',
  },
  {
    label: 'SPED Elementary',
    value: 'SPED Elementary',
  },
  {
    label: 'High School Undergraduate',
    value: 'High School Undergraduate',
  },
  {
    label: 'ALS Secondary',
    value: 'ALS Secondary',
  },
  {
    label: 'SPED Secondary',
    value: 'SPED Secondary',
  },
  {
    label: 'High School Graduate',
    value: 'High School Graduate',
  },
  {
    label: 'College Undergraduate',
    value: 'College Undergraduate',
  },
  {
    label: 'Post Secondary',
    value: 'Post Secondary',
  },
  {
    label: 'Post Secondary Graduate',
    value: 'Post Secondary Graduate',
  },
  {
    label: 'College Graduate',
    value: 'College Graduate',
  },
  {
    label: 'Post Baccalaureate',
    value: 'Post Baccalaureate',
  },
  {
    label: "Master's/PhD graduate",
    value: "Master's/PhD graduate",
  },
  {
    label: 'Not Reported',
    value: 'Not Reported',
  },
];

export const GENDER = [
  {
    label: 'MALE',
    value: 'MALE',
  },
  {
    label: 'FEMALE',
    value: 'FEMALE',
  },
];

export const CIVIL_STATUS = [
  {
    label: 'SINGLE',
    value: 'SINGLE',
  },
  {
    label: 'MARRIED',
    value: 'MARRIED',
  },
  {
    label: 'DIVORCED',
    value: 'DIVORCED',
  },
  {
    label: 'WIDOWED',
    value: 'WIDOWED',
  },
];

export const UPDATE_BUSINESS_EST = 'OHP/update_business_establishment';
export const REMOVE_BUSINESS_EST = 'OHP/remove_business_establishment';
export const CREATE_BUSINESS_EST = 'OHP/create_business_establishment';
